import { Component, OnInit } from "@angular/core";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
  SearchType,
  SliderType,
} from "@cvx/nextpage";
import { LoggedUserService } from "./services/common/logged-user.service";
import { RoutesService } from "./services/routes.service";
import { CalAngularService } from "@cvx/cal-angular";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.css"],
})
export class AppComponent implements OnInit {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;
  loggedUsername: string = "";
  facilityName: string = "";
  filteredRoutesLoaded: boolean = false;
  dataLoading: boolean = true;

  constructor(
    private NP: NextPageService,
    private loggedUserService: LoggedUserService,
    private authService: CalAngularService,
    private routesService: RoutesService
  ) {
    this.NP.options.sitename = "Emergency Response Tool";
    this.setLoggedUserInfo();
  }

  ngOnInit() {
    this.dataLoading = true;
    this.routesService.filteredRoutesLoaded.subscribe((loaded) => {
      if (loaded) {
        this.filteredRoutesLoaded = loaded;
        this.dataLoading = false;
      }
    });
  }


  setLoggedUserInfo() {
    if (this.authService.isUserSignedIn()) {
      let accountInfo = this.authService.getAccount();
      this.loggedUsername = accountInfo.username;

      forkJoin({
        facilityName: this.loggedUserService.getLoggedUserFacilityName(),
        userData: this.loggedUserService.getLoggedUserData()
      }).subscribe(results => {
        this.facilityName = results.facilityName;
        if (results.userData !== null) {
          this.loggedUserService.setLoggedUserData(results.userData);
        }
      });
    } else {
      this.authService.userInitiatedSignIn();
    }
  }

}
